/* unplugin-vue-components disabled */import script from "./company-history.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-history.vue?vue&type=script&setup=true&lang=ts"

import "./company-history.vue?vue&type=style&index=0&id=094d9efd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-094d9efd"]])

export default __exports__